module.exports = __webpack_public_path__ + "static/media/NG.6bc50e39.jpg";